import React, { useCallback, useEffect, useRef, useState } from 'react'
import '../styles/Form.css'
import Categorias from './Categorias';
import { useDarkMode } from '../utils/DarkModeProvider';
import { useAuth } from './AuthContext';
import darkModeStyles from '../styles/TableDarkMode'
import lightModeStyles from '../styles/TableLightMode'
import { ScaleLoader } from 'react-spinners';
import Swal from 'sweetalert2'
import PanelesCategorias from './PanelesCategorias';
import Instancias from './Instancias';
import { useGlobal } from '../utils/GlobalContext';
import { useNavigate } from "react-router-dom"
import PortadaPadre from '../utils/PortadaPadre';
import { useLocation } from "react-router-dom";

function Formulario() {

    const location = useLocation();

    const periodoSeleccionado = location.state?.evaluacion;
    const usuarioNavegacion = location.state?.usuario;

    const { user, logout, token } = useAuth();
    const usuarioActual = usuarioNavegacion || user;
    const { setGlobalState, globalState } = useGlobal()
    const navigate = useNavigate()

    const { darkMode, toggleDarkMode } = useDarkMode();
    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles
    const volverListadoButtonStyles = darkMode ? styles.volverListadoButtonDark : styles.volverListadoButtonLight
    const volverListadoButtonHover = darkMode ? styles.volverListadoButtonHoverDark : styles.volverListadoButtonHoverLight

    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [loading, setLoading] = useState(false)
    const [verificandoInstancias, setVerificandoInstancias] = useState(false)
    const [validandoEstadoDocente, setValidandoEstadoDocente] = useState(true)

    const volverACategoriasFnRef = useRef(null)
    const categoriaSeleccionadaRef = useRef(null)

    const esAdmin = usuarioActual?.rol === 'Admin'
    const esOperador = usuarioActual?.rol === 'Operador'

    const normalizarEstadoActual = (estado) => String(estado || '').trim().toLowerCase()

    useEffect(() => {
        if (!periodoSeleccionado?.id || !usuarioActual?.id || !token) {
            navigate('/home', {
                replace: true,
                state: { usuario: usuarioActual }
            })
            return
        }

        if (esOperador) {
            navigate('/resumen', {
                replace: true,
                state: {
                    evaluacion: periodoSeleccionado,
                    usuario: usuarioActual,
                    bloquearEdicion: true
                }
            })
            return
        }

        setValidandoEstadoDocente(true)

        fetch(`${process.env.REACT_APP_API_URL}/docente-portada/${usuarioActual.id}/${periodoSeleccionado.id}/`, {
            method: 'GET',
            headers: {
                accept: 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('No se pudo validar el estado del docente')
                }
                return response.json()
            })
            .then((docentePortada) => {
                const estadoActual = normalizarEstadoActual(docentePortada?.estado_actual)
                if (estadoActual === 'carga_cerrada') {
                    navigate('/resumen', {
                        replace: true,
                        state: {
                            evaluacion: periodoSeleccionado,
                            usuario: usuarioActual,
                            bloquearEdicion: true
                        }
                    })
                }
            })
            .catch((errorEstadoDocente) => {
                console.log(errorEstadoDocente)
            })
            .finally(() => {
                setValidandoEstadoDocente(false)
            })
    }, [periodoSeleccionado?.id, usuarioActual?.id, token, navigate, esOperador])

    useEffect(() => {
        if (usuarioActual?.id) {
            setGlobalState((prev) => ({
                ...prev,
                docenteId: usuarioActual.id,
                periodoId: periodoSeleccionado?.id || null
            }))
        }
    }, [usuarioActual?.id, periodoSeleccionado?.id])

    const formatearFecha = (fecha) => {
        if (!fecha || typeof fecha !== 'string' || !fecha.includes('-')) return fecha || '-'
        const [year, month, day] = fecha.split('-')
        return `${day}/${month}/${year}`
    }

    const tieneInstanciasParaMostrar = (nodos) => {
        if (!Array.isArray(nodos)) return false

        return nodos.some((nodo) => {
            if (!nodo) return false

            if (nodo.tipo === 'item') {
                return Array.isArray(nodo.instancias) && nodo.instancias.length > 0
            }

            if (nodo.tipo === 'categoria') {
                return tieneInstanciasParaMostrar(Object.values(nodo.hijos || {}))
            }

            return false
        })
    }

    const estadosPendientes = new Set([
        'creado_por_docente',
        'modificado_por_docente'
    ])

    const normalizarEstado = (estado) => {
        const estadoCrudo = typeof estado === 'string' ? estado : estado?.estado
        return String(estadoCrudo || '').trim().toLowerCase()
    }

    const estaPendiente = (estado) => estadosPendientes.has(normalizarEstado(estado))

    const hayInstanciasEnEstadoGlobal = globalState.items.some(
        (item) => Array.isArray(item.instancias) && item.instancias.length > 0
    )

    const hayInstanciasSinVerificar = globalState.items.some(
        (item) => Array.isArray(item.instancias) && item.instancias.some((instancia) => estaPendiente(instancia.estado))
    )

    const categoriaActiva = categoriaSeleccionada ? Object.values(categoriaSeleccionada)[0] : null
    const indiceCategoriaActiva = categoriaActiva?.indice_completo

    const verificarInstanciasCategoria = () => {
        if (!indiceCategoriaActiva || !usuarioActual?.id || !periodoSeleccionado?.id || !token) {
            Swal.fire({
                icon: 'warning',
                title: 'No se pudo verificar',
                text: 'No se encontró la categoría seleccionada o el usuario actual.',
                confirmButtonText: 'Cerrar',
                confirmButtonColor: '#972034'
            })
            return
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: `Esta acción verificará todos los items pendientes de la categoría seleccionada ${categoriaActiva?.categoria.nombre || 'desconocida'}.`,
            icon: 'question',
            showCancelButton: true,
            background: darkMode ? '#1e1e1e' : '#fff',
            color: darkMode ? '#fff' : '#545454',
            confirmButtonColor: darkMode ? '#66BB6A' : '#4CAF50',
            cancelButtonColor: darkMode ? '#e57373' : '#d9534f',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (!result.isConfirmed) return

            setVerificandoInstancias(true)
            fetch(
                `${process.env.REACT_APP_API_URL}/item-instancias/confirmar-categoria-instancias/${usuarioActual.id}/${encodeURIComponent(indiceCategoriaActiva)}/${periodoSeleccionado.id}/`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: ''
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Error al verificar instancias de la categoría')
                    }

                    setGlobalState((prev) => ({
                        ...prev,
                        items: prev.items.map((item) => {
                            if (!item.indice_completo?.startsWith(`${indiceCategoriaActiva}.`)) return item

                            return {
                                ...item,
                                instancias: (item.instancias || []).map((instancia) => {
                                    if (!estaPendiente(instancia.estado)) return instancia

                                    return {
                                        ...instancia,
                                        estado: 'confirmado_por_docente'
                                    }
                                })
                            }
                        })
                    }))

                    Swal.fire({
                        icon: 'success',
                        title: 'Items verificados',
                        text: 'Se verificaron los items de la categoría correctamente.',
                        timer: 1800,
                        showConfirmButton: false
                    })
                })
                .catch((error) => {
                    console.log(error)
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudieron verificar los items de la categoría.',
                        confirmButtonText: 'Cerrar',
                        confirmButtonColor: '#972034'
                    })
                })
                .finally(() => {
                    setVerificandoInstancias(false)
                })
        })
    }

    const volverACategorias = useCallback(() => {
        setGlobalState({
            "item_periodo": 0,
            "items": [],
            "docenteId": usuarioActual.id,
            "periodoId": periodoSeleccionado?.id || null
        })
        setCategoriaSeleccionada(null)
    }, [usuarioActual?.id, periodoSeleccionado?.id, setGlobalState])

    // Mantener la ref siempre actualizada para usarla en el listener
    useEffect(() => {
        volverACategoriasFnRef.current = volverACategorias
    }, [volverACategorias])

    // Mantener la categoría actual en ref para que el listener global use el estado más reciente
    useEffect(() => {
        categoriaSeleccionadaRef.current = categoriaSeleccionada
    }, [categoriaSeleccionada])

    // Interceptar back dentro de Formulario:
    // - Si hay categoría seleccionada, se limpia (equivale a "Volver").
    // - Si no hay categoría, no hace nada.
    // En ambos casos se mantiene una entrada guardia en historial para no salir de /formulario.
    useEffect(() => {
        const pushGuardEntry = () => {
            const currentHistoryState = window.history.state && typeof window.history.state === 'object'
                ? window.history.state
                : {}

            window.history.pushState(
                {
                    ...currentHistoryState,
                    formularioBackGuard: true,
                    ts: Date.now()
                },
                ''
            )
        }

        // Inicializa la entrada guardia al montar Formulario.
        pushGuardEntry()

        const handlePopState = () => {
            if (categoriaSeleccionadaRef.current) {
                volverACategoriasFnRef.current?.()
            }

            // Reponer guardia para que el back no salga de Formulario.
            pushGuardEntry()
        }

        window.addEventListener('popstate', handlePopState)
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])

    const salir = () => {
        Swal.fire({
            title: "¿Seguro deseas salir?",
            text: "Todos los cambios fueron guardados.",
            icon: "question",
            showCancelButton: true,
            background: darkMode ? "#1e1e1e" : "#fff",
            color: darkMode ? "#fff" : "#545454",
            confirmButtonColor: darkMode ? "#66BB6A" : "#4CAF50",
            cancelButtonColor: darkMode ? "#e57373" : "#d9534f",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                logout()
            }
        })
    }

    const volverAlHome = () => {
        navigate('/home', { replace: true })
    }

    const finalizarCarga = async () => {
        if (!periodoSeleccionado?.id || !usuarioActual?.id || !token) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo validar el estado de los items.',
                confirmButtonText: 'Cerrar',
                confirmButtonColor: '#972034'
            })
            return
        }

        navigate('/resumen', {
            state: {
                evaluacion: periodoSeleccionado,
                usuario: usuarioActual
            }
        })
    }

    return (
        <div className={darkMode ? "div-container-dark-mode" : "div-container-light-mode"} data-bs-theme={darkMode ? "dark" : "light"}>
            {/* <button
                style={dynamicStyles.logoutButtonUpRight}
                onMouseOver={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButtonHover.backgroundColor}
                onMouseOut={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButton.backgroundColor}
                onClick={logout}
            >
                Cerrar sesión
            </button> */}
            <img src={darkMode ? require('../assets/images/logo_unq_negativo_blanco.png') : require('../assets/images/logo_unq_negativo_negro_rojo.png')} className="unqImage" />
            <div className="toggle-container">
                <label className="toggle-switch">
                    <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
                    <span className="slider"></span>
                    <span className="toggle-icons">
                        {darkMode ? '🌙' : '☀️'}
                    </span>
                </label>
            </div>

            <div className="container mt-5 mb-4">
                <div className="card shadow-lg p-4">
                    <h1 className="text-center mb-4" style={{ fontSize: '1.7rem' }}>Evaluación de Desempeño Docente</h1>
                    {periodoSeleccionado && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                            <div style={{ ...dynamicStyles.card, marginTop: 0, padding: '12px 16px', width: 'fit-content', textAlign: 'center' }}>
                                <p style={{ margin: 0 }}>
                                    <strong>Período:</strong> {formatearFecha(periodoSeleccionado.fecha_inicio)} - {formatearFecha(periodoSeleccionado.fecha_fin)}
                                </p>
                                <p style={{ margin: '6px 0 0 0' }}>
                                    <strong>Descripción:</strong> {periodoSeleccionado.descripcion || '-'}
                                </p>
                            </div>
                        </div>
                    )}
                    {(loading || validandoEstadoDocente) ?
                        <div style={{ alignSelf: 'center' }}>
                            <ScaleLoader color='#972034' />
                        </div>
                        :
                        <>
                            {token && <PortadaPadre token={token} idDocente={usuarioActual.id} periodoId={periodoSeleccionado?.id} rol={usuarioActual?.rol} />}
                            {categoriaSeleccionada ? (
                                <>
                                    <Categorias data={Object.values(categoriaSeleccionada)} onVolver={volverACategorias} />
                                    {(tieneInstanciasParaMostrar(Object.values(categoriaSeleccionada)) || hayInstanciasEnEstadoGlobal) && (
                                        <div className="mb-2">
                                            <h2 className="pb-2" style={dynamicStyles.title}>Ítems</h2>
                                            <Instancias dataList={Object.values(categoriaSeleccionada)} />
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: hayInstanciasSinVerificar ? 16 : 0, width: '100%' }}>
                                        <button
                                            style={{ ...dynamicStyles.logoutButton, fontSize: 16, padding: '10px 0', width: '100%', flex: 1 }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.logoutButtonHover.backgroundColor}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.logoutButton.backgroundColor}
                                            onClick={volverACategorias}
                                        >
                                            Volver
                                        </button>
                                        {hayInstanciasSinVerificar && (
                                            <button
                                                style={{ ...dynamicStyles.buttonVerificar, fontSize: 16, padding: '10px 0', width: '100%', flex: 1 }}
                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.verificarButtonHover.backgroundColor}
                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.buttonVerificar.backgroundColor}
                                                onClick={verificarInstanciasCategoria}
                                                disabled={verificandoInstancias}
                                            >
                                                {verificandoInstancias ? 'Verificando...' : 'Verificar Items'}
                                            </button>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <PanelesCategorias onCategoriaSeleccionada={setCategoriaSeleccionada} periodoSeleccionado={periodoSeleccionado} docenteId={usuarioActual.id} />
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                                        <button
                                            style={{ ...styles.actionButtonBase, ...volverListadoButtonStyles }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = volverListadoButtonHover.backgroundColor}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = volverListadoButtonStyles.backgroundColor}
                                            onClick={volverAlHome}
                                        >
                                            Volver al Inicio
                                        </button>
                                        <button
                                            style={{ ...dynamicStyles.logoutButton, ...styles.actionButtonBase }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.logoutButtonHover.backgroundColor}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.logoutButton.backgroundColor}
                                            onClick={esAdmin ? volverAlHome : salir}
                                        >
                                            {esAdmin ? 'Volver' : 'Salir'}
                                        </button>
                                        <button
                                            style={{ ...dynamicStyles.buttonVerificar, ...styles.actionButtonBase }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.verificarButtonHover.backgroundColor}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = dynamicStyles.buttonVerificar.backgroundColor}
                                            onClick={finalizarCarga}
                                        >
                                            Previsualizar Datos
                                        </button>
                                    </div>
                                </>
                            )}
                        </>
                    }
                </div>
            </div>


        </div>
    );
}

const styles = {
    actionButtonBase: {
        flex: 1,
        width: '100%',
        minHeight: '44px',
        padding: '10px 16px',
        fontSize: 16,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    volverListadoButtonLight: {
        backgroundColor: '#818794',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background 0.3s'
    },
    volverListadoButtonHoverLight: {
        backgroundColor: '#4b5563'
    },
    volverListadoButtonDark: {
        backgroundColor: '#6b7280',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background 0.3s'
    },
    volverListadoButtonHoverDark: {
        backgroundColor: '#4b5563'
    }
}

export default Formulario